export default __webpack_public_path__ + "static/media/Transfer_Disble.a77a37c1.svg";